const BASE_URL = "https://venkatmcajj.github.io/react-country-state-city/data";

let locationPromise = null;

async function fetchJson(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.status}`);
  }

  return response.json();
}

async function getLocationData() {
  if (!locationPromise) {
    locationPromise = Promise.all([
      fetchJson(`${BASE_URL}/countriesminified.json`),
      fetchJson(`${BASE_URL}/statesminified.json`),
      fetchJson(`${BASE_URL}/citiesminified.json`),
    ])
      .then(([countries, stateData, cityData]) => {
        const countryMap = new Map();
        const stateMap = new Map();
        const cityMap = new Map();

        const statesByCountry = new Map();
        const citiesByState = new Map();

        // Countries
        countries.forEach((country) => {
          countryMap.set(Number(country.id), country);
        });

        // States
        stateData.forEach((country) => {
          const states = country.states || [];

          statesByCountry.set(Number(country.id), states);

          states.forEach((state) => {
            state.countryId = Number(country.id);
            stateMap.set(Number(state.id), state);
          });
        });

        // Cities
        cityData.forEach((country) => {
          (country.states || []).forEach((state) => {
            const cities = state.cities || [];

            citiesByState.set(
              `${Number(country.id)}-${Number(state.id)}`,
              cities,
            );

            cities.forEach((city) => {
              city.countryId = Number(country.id);
              city.stateId = Number(state.id);

              cityMap.set(Number(city.id), city);
            });
          });
        });

        return {
          countries,
          countryMap,
          stateMap,
          cityMap,
          statesByCountry,
          citiesByState,
        };
      })
      .catch((error) => {
        // Allow retry on the next call
        locationPromise = null;
        console.error("Failed to load location data:", error);
        throw error;
      });
  }

  return locationPromise;
}

export async function GetCountries() {
  try {
    const { countries } = await getLocationData();
    return countries;
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function GetState(countryId) {
  try {
    const { statesByCountry } = await getLocationData();

    return statesByCountry.get(Number(countryId)) || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function GetCity(countryId, stateId) {
  try {
    const { citiesByState } = await getLocationData();

    return citiesByState.get(`${Number(countryId)}-${Number(stateId)}`) || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function GetCountryById(id) {
  try {
    const { countryMap } = await getLocationData();
    return countryMap.get(Number(id)) || null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function GetStateById(id) {
  try {
    const { stateMap } = await getLocationData();
    return stateMap.get(Number(id)) || null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function GetCityById(id) {
  try {
    const { cityMap } = await getLocationData();
    return cityMap.get(Number(id)) || null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function clearLocationCache() {
  locationPromise = null;
}
